import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { StorageService } from 'app/services/storage.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { FTPStorage } from 'app/models/storage';
import { Tag } from 'app/models/tag';
import { TagService } from 'app/services/tag.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-add-ftpstorage',
  templateUrl: './add-ftpstorage.component.html',
  styleUrls: ['./add-ftpstorage.component.scss']
})
export class AddFTPStorageComponent implements OnInit {
  ftpForm: FormGroup;
  storageId: number;
  loading: boolean = false;

  isNgSelectLoading: boolean = false;

  constructor(private validationHandler: ValidationHandler,
    public storageService: StorageService, private navigateRoute: Router,
    private toastService: ToastService, private _route: ActivatedRoute,
    public tagService: TagService, private ecoDocsTitleService: EcoDocsTitleService) {

    // FTP form group
    this.ftpForm = this.storageService.getFTPFormGroup();


    //Get FTP driver for edit 
    this._route.params.subscribe(params => {
      if (params.storageid) {
        this.storageId = +params.storageid;
        this.loading = true;
        storageService.getById(this.storageId).pipe(finalize(() => {
          this.loading = false;
        })).subscribe(f => {
          this.ftpForm.patchValue(f);
        });
      }
    });
  }
  
  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Add FTP Storage', false );
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }

  encryptionOptions = [
    { label: 'No Encryption', value: 0 },
    { label: 'TLS/SSL encryption', value: 1 }
  ]

  showPassword(input) {
    if (input.type == "text") {
      input.type = "password"
    }
    else {
      input.type = "text"
    }
  }
  submit(frm: FormGroup) {
    this.loading = true;
    if (!frm.valid) {
      this.validationHandler.onSubmitCheck(frm);
      this.loading = false;
      return;
    }
    if (this.storageId) {
      this.storageService.updateFtp(frm.value as FTPStorage).subscribe(t => {
        this.loading = false;
        this.navigateRoute.navigateByUrl('/manage/storage')
      }, err => {
        debugger;
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, this.ftpForm);
        }
        else
          this.toastService.error("Save Failed");
      });
    }
    else {
      this.storageService.addFtp(frm.value as FTPStorage).subscribe(t => {
        this.loading = false;
        this.navigateRoute.navigateByUrl('/manage/storage')
      }, err => {
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, this.ftpForm);
        }
        else
          this.toastService.error("Save Failed");
      });
    }
  }

  testConnection() {
    if (!this.ftpForm.valid) {
      this.validationHandler.onSubmitCheck(this.ftpForm);
      return;
    }

    this.loading = true;
    this.storageService.ftptestConnection(this.ftpForm.value as FTPStorage).pipe(finalize(() => {
      this.loading = false;
    })).subscribe(t => {
      this.toastService.success("Connection Succeeded!");
    }, err => {
      if (err.status === 422) {
        this.validationHandler.serverValidationHandler(err, this.ftpForm);
      }
      else {
        this.toastService.error("Connection Failed!");
      }
    });

  }

}
